module.exports = "<div class=\"card\">\r\n    <canvas id=\"myChart2\">\r\n    {{myChart}}\r\n  </canvas>\r\n</div>\r\n    \r\n"